import { motion } from "framer-motion";
import { formatRupiah } from "@/lib/dirga";

export const Confirmation = ({ total, whatsappLink, onBack }) => {
  return (
    <section className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="w-full max-w-xl"
      >
        <p className="font-sans text-xs uppercase tracking-[0.5em] text-[#B9B2A4]">
          DIRGA
        </p>
        <h1
          className="mt-8 font-serif text-5xl font-light tracking-tight text-[#1C1C1C] sm:text-6xl"
          data-testid="confirmation-title"
        >
          Terima Kasih.
        </h1>
        <p className="mt-6 font-serif text-xl italic text-[#5C5C5C]">
          Cerita pernikahanmu sudah kami terima.
        </p>
        <p className="mt-4 font-sans text-sm leading-relaxed text-[#8A8A8A]">
          Paket dan detail yang kamu pilih sudah terkirim ke DIRGA. Kami akan
          segera menghubungimu kembali.
        </p>

        <div className="mx-auto mt-10 max-w-xs border-t border-b border-[#E8E3D9] py-6">
          <p className="font-sans text-[11px] uppercase tracking-[0.25em] text-[#8A8A8A]">
            Estimasi Biaya
          </p>
          <p className="mt-2 font-serif text-4xl text-[#1C1C1C]" data-testid="confirmation-total">
            {formatRupiah(total)}
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
          <button
            type="button"
            data-testid="back-to-calculator-btn"
            onClick={onBack}
            className="w-full border border-[#1C1C1C] px-8 py-4 font-sans text-sm uppercase tracking-widest text-[#1C1C1C] transition-colors hover:bg-[#1C1C1C] hover:text-white sm:w-auto"
          >
            Back to Calculator
          </button>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-dirga-btn"
            className="w-full bg-[#1C1C1C] px-8 py-4 font-sans text-sm uppercase tracking-widest text-white transition-colors hover:bg-[#333333] sm:w-auto"
          >
            Hubungi DIRGA
          </a>
        </div>
      </motion.div>
    </section>
  );
};
